import {
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
  SimpleChanges,
} from "@angular/core";
import { EditBlockViewModel } from "./edit-block.view-model";

@Component({
  selector: "evrideo-edit-block-header",
  templateUrl: "./edit-block-header.component.html",
  styleUrls: ["./edit-block-header.component.scss"],
})
export class EditBlockHeaderComponent implements OnInit {
  @Input()
  vm: EditBlockViewModel;
  constructor(private changeDetectorRef: ChangeDetectorRef) {}

  get isBlockStack(): boolean {
    return this.vm.isBlockStack;
  }

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges) {
    this.changeDetectorRef.detectChanges();
  }

  BlockStackToggleChange(event: any) {
    if (event === "Block") {
      this.vm.toggleBlockStack(false);
    } else {
      this.vm.toggleBlockStack(true);
    }
  }
}
